(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ff-compartir"] && !Shopify.designMode) return;
  try {
    // Compartir prenda: usa el menú del teléfono si existe; si no, copia el enlace y avisa "¡Enlace copiado!".
  if (!customElements.get('ff-compartir')) {
    customElements.define(
      'ff-compartir',
      class FfCompartir extends HTMLElement {
        connectedCallback() {
          const boton = this.querySelector('[data-compartir]');
          const texto = this.querySelector('[data-texto]');
          if (!boton || !texto) return;
          const original = texto.textContent;
          boton.addEventListener('click', async () => {
            const datos = { title: this.dataset.titulo, url: this.dataset.enlace };
            if (navigator.share) {
              try {
                await navigator.share(datos);
              } catch (error) {
                // La clienta cerró el menú de compartir: no hay nada que hacer.
              }
              return;
            }
            try {
              await navigator.clipboard.writeText(datos.url);
              texto.textContent = '¡Enlace copiado!';
              setTimeout(() => (texto.textContent = original), 2000);
            } catch (error) {
              window.prompt('Copia este enlace:', datos.url);
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
